import type { AssetTypeLite } from "@/entities/asset-type";
import type { UseListOptions } from "@/hooks/queries";
import type { Int } from "@/types";

import { useList } from "@/hooks/queries";

import { ASSET_TYPES_FILTERS } from "./asset-types.enum";

export const useGetAssetTypes = (options?: UseListOptions<AssetTypeLite>) => {
  const { data, ...queryResult } = useList<AssetTypeLite>(
    "assetTypes",
    options
  );

  return {
    assetTypes: data?.data ?? [],
    ...queryResult,
  };
};

export const useGetEntityTemplateAssetTypes = (entityTemplateId: Int) =>
  useGetAssetTypes({
    params: { [ASSET_TYPES_FILTERS.ENTITY_TEMPLATE_ID]: entityTemplateId },
  });
